import React from "react";

interface ErrorBoundaryState {
  error: Error | null;
}

/**
 * Garde-fou global : sans lui, une exception levee pendant le rendu demonte la
 * racine React et l'utilisateur ne voit qu'une page blanche, sans aucun log.
 */
class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  ErrorBoundaryState
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("Erreur de rendu non geree :", error, errorInfo.componentStack);
  }

  render() {
    const { error } = this.state;

    if (!error) {
      return this.props.children;
    }

    return (
      <div className="flex flex-col items-center justify-center gap-4 h-screen p-6 text-center">
        <i className="pi pi-exclamation-triangle text-4xl text-red-600" />
        <h1 className="text-xl font-semibold">Une erreur est survenue</h1>
        <p className="text-gray-600">
          La page n'a pas pu s'afficher. Vous pouvez recharger l'application ; si
          le probleme persiste, signalez le message ci-dessous au support.
        </p>
        <code className="text-sm text-red-700 break-all max-w-xl">
          {error.message}
        </code>
        <button
          type="button"
          className="p-button p-component"
          onClick={() => window.location.reload()}
        >
          <span className="p-button-label">Recharger la page</span>
        </button>
      </div>
    );
  }
}

export default ErrorBoundary;
